import React from 'react';
import styled from 'styled-components';

import type { IPopularDestinationsOfferWithPrice } from 'src/routes/Home/store/popularDestinationsOffers/types';

import Card from '../../../../Card';
import CountryContentWrapper from '../../../../CountryContentWrapper';
import CountryBackgroundImage from '../../../../CountryBackgroundImage';
import { CardHeadingBlock } from './CardHeadingBlock';
import { CardLabels } from './CardLabels';

import { RELINKING_VARIANTS } from '../../../../../constants';

interface ICountryWithPrices extends IPopularDestinationsOfferWithPrice {
  isMobile: boolean;
}

export const CountryWithPrices = (props: ICountryWithPrices) => {
  const { isMobile, adults, link, minPrice, nights, place, regions, imageUrl } =
    props;

  if (!minPrice) {
    return null;
  }

  return (
    <Card
      $isMobile={isMobile}
      $variant={RELINKING_VARIANTS.COUNTRIES_WITH_PRICES}
    >
      <StyledLink href={`${link}?ref_content=main_page`}>
        <CountryBackgroundImage src={imageUrl} />
        <StyledContentWrapper>
          <CardHeadingBlock
            place={place}
            minPrice={minPrice}
            nights={nights}
            adults={adults}
          />
          <LabelsContainer>
            <CardLabels regions={regions} />
          </LabelsContainer>
        </StyledContentWrapper>
      </StyledLink>
    </Card>
  );
};

const StyledLink = styled.a`
  display: block;
  height: 100%;
`;

const StyledContentWrapper = styled(CountryContentWrapper)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;

  padding: 8px 10px 10px 10px;
  box-sizing: border-box;
`;

const LabelsContainer = styled.div`
  height: 124px;
  position: relative;
`;
